export default (event, app) => {
  console.log('[PromotionsNotFound] No completed promotions were found.')
  app.$store.commit('order/setPromotionsAreChecking', false)
}
